import styled from "styled-components";
import { v } from "../../styles/variables";

export const Slider = styled.div`
	.slide-in {
		position: fixed;
		top: ${v.headerHeight};
		left: 0;
		min-height: calc(100vh - ${v.headerHeight});
		width: 100%;
		background: ${({ theme }) => theme.primary2};
		transform-origin: left;
		z-index: 99;
	}

	.slide-out {
		position: fixed;
		top: ${v.headerHeight};
		left: 0;
		min-height: calc(100vh - ${v.headerHeight});
		width: 100%;
		background: ${({ theme }) => theme.primary2};
		transform-origin: right;
		z-index: 99;
	}
`;
